import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CRM from './components/CRM';
import LoginPage from './components/LoginPage';
import Documentation from './components/Documentation';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './hooks/useAuth';
import { createContext } from 'react';

export const UsersContext = createContext();

function App() {
  const { isAuthenticated, isLoading } = useAuth();
  
  // Modifica qui: carica lo stato da localStorage al mount
  const [usersState, setUsersState] = useState(() => {
    // Verifica se ci sono dati salvati in localStorage
    const savedUsers = localStorage.getItem('usersState');
    return savedUsers ? JSON.parse(savedUsers) : [];
  });

  // Effetto per salvare lo stato in localStorage quando cambia
  useEffect(() => {
    if (usersState.length > 0) {
      localStorage.setItem('usersState', JSON.stringify(usersState));
    }
  }, [usersState]);

  // Wrapper per setUsersState che aggiorna sia lo stato che localStorage
  const updateUsersState = (newState) => {
    // Se newState è una funzione (come in setUsersState(prev => ...))
    if (typeof newState === 'function') {
      setUsersState(prev => {
        const updated = newState(prev);
        localStorage.setItem('usersState', JSON.stringify(updated));
        return updated;
      });
    } else {
      // Se newState è un valore diretto
      setUsersState(newState);
      localStorage.setItem('usersState', JSON.stringify(newState));
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  return (
    <UsersContext.Provider value={{ usersState, setUsersState: updateUsersState }}>
      <Router>
        <Routes>
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/" /> : <LoginPage />
          } />
          <Route path="/" element={
            <ProtectedRoute>
              <CRM />
            </ProtectedRoute>
          } />
          <Route path="/documentation" element={<Documentation />} />
        </Routes>
      </Router>
    </UsersContext.Provider>
  );
}

export default App;